import React from 'react';
import home from '../../assets/images/home.svg';

const Home = (props) => {
    return (
        <div className="home-module" >
            <div className="home-module__content">
                <h1 className="home-module__content-heading">iConnect</h1>
                <p className="home-module__content-text">Connect with everyone.</p>
            </div>
            <div className="home-module__image">
                <img src={home} alt="HomeImage" />
            </div>
        </div >
    )
}

export default Home;


// <p className="home-module__content-text">Here are some amazing things you can do:</p>
// <ul className="home-module__content-text">
//     <li>Video Chat with Strangers</li>
//     <li>Text Chat with friends</li>
//     <li>Lot's of fun with Emoji's based on your mood</li>
// </ul>